
import Vue from "vue";
import { fetchWithBackoff } from "../../utils/fetchWithBackoff";

const DeviceAPIService = class extends Vue {
  _DEBUG = false;

  constructor() {
    super();
    if (this._DEBUG) {
      this.debugMessage('BOOTSTRAPPED DEVICE API SERVICE');
    }
  }

  debugMessage(message) {
    if (this._DEBUG) {
      console.log(message);
    }
  }

  async getDevices(tenant, query = { limit: 30, skip: 0 }) {
    if (!tenant || !config) return;

    const claims = await this.$auth.getIdTokenClaims();
    const id_token = claims.__raw;
    if (!id_token) return;

    const url = `${config.OPERATIONS_SERVICE}/tenants/${tenant}/devices?${new URLSearchParams(query).toString()}`;
    const request = new Request(url, {
      method: "GET",
      mode: "cors",
      cache: "default",
      withCredentials: true,
      credentials: "include",
      headers: {
        Authorization: "Bearer " + id_token,
        "Content-Type": "application/json",
      },
    });

    return fetchWithBackoff(request);
  }

  async getBedsWithAttributes(tenant, query = { limit: 30, skip: 0 }, message = {}) {
    if (!tenant || !config) return;

    const claims = await this.$auth.getIdTokenClaims();
    const id_token = claims.__raw;
    if (!id_token) return;

    const url = `${config.API_GATEWAY_APIGEE}/tenants/${tenant}/beds-attributes?${new URLSearchParams(query).toString()}`;
    const request = new Request(url, {
      method: "POST",
      mode: "cors",
      cache: "default",
      headers: {
        Authorization: "Bearer " + id_token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(message),
    });

    return fetchWithBackoff(request);
  }

  async getDeviceAttributes(tenant, deviceId) {
    if (!tenant || !config || !deviceId) return;

    const claims = await this.$auth.getIdTokenClaims();
    const id_token = claims.__raw;
    if (!id_token) return;

    const url = `${config.API_GATEWAY_APIGEE}/tenants/${tenant}/devices/${deviceId}/attributes/BED_PROPERTIES`;
    const request = new Request(url, {
      method: "GET",
      mode: "cors",
      cache: "default",
      headers: {
        Authorization: "Bearer " + id_token,
        "Content-Type": "application/json",
      },
    });

    return fetchWithBackoff(request);
  }
};

// Singleton Pattern Instantiate
if (!Vue.prototype.$DeviceAPIService) {
  Vue.prototype.$DeviceAPIService = new DeviceAPIService();
}

export default Vue.prototype.$DeviceAPIService;
